import { lazy } from "react";
import { Route } from "react-router";
import { UserMenu } from "../../types/authTypes";

const useRouter = ({ userData }: { userData: UserMenu[] | undefined }) => {
  const routes = userData?.map((route: UserMenu) => {
    const Component = lazy(
      () => import(`../../pages/${route.name}/${route.page}`)
    );

    return <Route key={route.to} path={route.to} element={<Component />} />;
  });

  return routes;
};

export default useRouter;
